import React, {Component} from "react";
import {Table} from "reactstrap";
import "./History.css";
import Loading from "../../common/Loading/Loading";
import toastr from "toastr";
import ToastOptions from "../../common/toast/toastr-config";
import UserService from "../../services/user-service";
import ReactPaginate from 'react-paginate';
import moment from "moment-timezone";

class History extends Component {

    mount = false;

    constructor(props) {
        super(props);
        this.state = {
            logs: [],
            current_page_logs: [],
            page: 0,
            per_page: 5,
            pages_count: 0,
        };
    }

    componentDidMount() {
        this.mount = true;
        this.fetchLogs();
    }

    componentWillUnmount() {
        this.mount = false;
    }

    fetchLogs = async () => {
        const userId = this.props.id;
        try {
            if (this.mount) {
                this.setState({loading: true});
            }
            const response = await UserService.getLogsByUserId(userId, {
                page: this.state.page,
                per_page: 100 //Hardcoded value is needed for workaround of the pagination issue
            });

            if (this.mount) {
                this.setState({
                    logs: response.logs,
                    current_page_logs: response.logs.slice(0, 5),
                    loading: false,
                    pages_count: Math.ceil(response.logs.length / this.state.per_page)
                });

            }
        } catch (error) {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    changePage = value => {
        const _page = value.selected;
        if (_page >= 0 && _page < this.state.pages_count) {
            const nextPageBounds = {
                start : (_page * this.state.per_page),
                end: (_page * this.state.per_page) + this.state.per_page
            };
            const nextPageItems = this.state.logs.slice(nextPageBounds.start, nextPageBounds.end);

            this.setState({
                page: _page,
                current_page_logs: nextPageItems
            }, () => {

            });
        }
    };

    renderLogs = () => {
        return (this.state.current_page_logs.map((log, i) => {
            return (
                <tr key={`${log.type}${i}`}>
                    <td>{log.type}</td>
                    <td>{moment(log.date).fromNow()}</td>
                    <td>{log.client_name}</td>
                    <td>{log.ip}</td>
                    <td>{log.location_info.country_name}</td>
                </tr>
            );
        }));
    };

    render() {
        return (
            <div className="user-history">
                <Table>
                    <thead>
                    <tr>
                        <th>Events</th>
                        <th>When</th>
                        <th>App</th>
                        <th>IP Address</th>
                        <th>From</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.loading
                        ? <tr>
                            <td><Loading/></td>
                        </tr>
                        : this.renderLogs()
                    }
                    </tbody>
                </Table>
                {!this.state.loading && this.state.logs.length > 0 && (
                    <div className="pagination-div">
                        <div className={`pagination ${this.props.className}`}>
                            <ReactPaginate previousLabel={"‹"}
                                           nextLabel={"›"}
                                           breakLabel={<a>...</a>}
                                           breakClassName={"ellipsis disabled"}
                                           forcePage={+(this.state.page)}
                                           onPageChange={this.changePage}
                                           pageCount={this.state.pages_count}
                                           marginPagesDisplayed={1}
                                           pageRangeDisplayed={3}
                                           containerClassName={"pagination"}
                                           subContainerClassName={"pages pagination"}
                                           activeClassName={"active"}
                            />
                        </div>
                    </div>
                )}
                {!this.state.loading && this.state.logs.length === 0 && (
                    <div>
                        No history events available for {this.props.userName}.
                    </div>
                )}
            </div>
        );
    }
}

export default History;



// WEBPACK FOOTER //
// ./src/user-profile/components/History.js